const C = {
  name: "DocumentFilled",
  dimensions: { width: 28, height: 41 },
  content: `
    <g fill="currentColor" stroke="none" clip-path="url(#clip0_12_3858)">
    <path d="M2 37.0029V2.00293H15C15.55 2.00293 16 2.45293 16 3.00293V10.0029C16 11.1029 16.9 12.0029 18 12.0029H25C25.55 12.0029 26 12.4529 26 13.0029V38.0029H3C2.45 38.0029 2 37.5529 2 37.0029ZM18 3.41293L24.59 10.0029H19C18.45 10.0029 18 9.55293 18 9.00293V3.41293ZM27.41 10.0029L18 0.59293C17.62 0.21293 17.12 0.00292969 16.59 0.00292969H2C0.9 0.00292969 0 0.90293 0 2.00293V38.0029C0 39.1029 0.9 40.0029 2 40.0029H26C27.1 40.0029 28 39.1029 28 38.0029V11.4129C28 10.8829 27.79 10.3829 27.41 10.0029Z" />
    <path d="M22 33.0029H6C5.45 33.0029 5 33.4529 5 34.0029C5 34.5529 5.45 35.0029 6 35.0029H22C22.55 35.0029 23 34.5529 23 34.0029C23 33.4529 22.55 33.0029 22 33.0029Z" />
    <path d="M22 28.0029H6C5.45 28.0029 5 28.4529 5 29.0029C5 29.5529 5.45 30.0029 6 30.0029H22C22.55 30.0029 23 29.5529 23 29.0029C23 28.4529 22.55 28.0029 22 28.0029Z" />
    <path d="M22 23.0029H6C5.45 23.0029 5 23.4529 5 24.0029C5 24.5529 5.45 25.0029 6 25.0029H22C22.55 25.0029 23 24.5529 23 24.0029C23 23.4529 22.55 23.0029 22 23.0029Z" />
    <path d="M6 20.0029H22C22.55 20.0029 23 19.5529 23 19.0029C23 18.4529 22.55 18.0029 22 18.0029H6C5.45 18.0029 5 18.4529 5 19.0029C5 19.5529 5.45 20.0029 6 20.0029Z" />
    </g>
    <defs>
    <clipPath id="clip0_12_3858">
    <rect width="28" height="40" fill="currentColor" transform="translate(0 0.00292969)"/>
    </clipPath>
    </defs>

    </g>
  `
};
export {
  C as DocumentFilled
};
